import { useSelector } from 'react-redux';

// Roles come from the authenticated session. Unknown/legacy roles fail closed;
// administrator=true alone cannot imply tenant operational access.
export const operationalCapabilities = (user, server = {}) => {
  const role = user?.role;
  const tenant = user?.tenantId != null;
  const writable = tenant && !user?.readonly && !server?.readonly;
  const administrator = writable && role === 'TENANT_ADMINISTRATOR';
  const operator = writable && (administrator || role === 'PLANT_OPERATOR');
  // A haulier account belongs to the company that owns the trucks, not to the plant. It reads its
  // own fleet and registers vehicles into it; every operational write stays shut.
  const haulier = writable && role === 'TRANSPORTER';
  return {
    read: tenant && ['STANDARD_USER', 'PLANT_OPERATOR', 'TENANT_ADMINISTRATOR', 'TRANSPORTER'].includes(role),
    operate: operator,
    administer: administrator,
    haulier,
    provision: role === 'PLATFORM_ADMINISTRATOR',
  };
};

export default () => useSelector((state) => operationalCapabilities(state.session.user, state.session.server));
